import type { PremioDraft } from './types';

// Formata centavos como dinheiro: "R$ 1.260,00".
export function formatarCentavos(centavos: number): string {
  const reais = Math.floor(centavos / 100);
  const cents = centavos % 100;
  return `R$ ${reais.toLocaleString('pt-BR')},${String(cents).padStart(2, '0')}`;
}

// Formata um número inteiro com separador de milhar: "6.300".
export function formatarNumero(n: number): string {
  return Math.round(n).toLocaleString('pt-BR');
}

// Máscara de CNPJ: 00.000.000/0000-00.
export function mascaraCNPJ(v: string): string {
  const d = v.replace(/\D/g, '').slice(0, 14);
  if (d.length <= 2) return d;
  if (d.length <= 5) return `${d.slice(0, 2)}.${d.slice(2)}`;
  if (d.length <= 8) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5)}`;
  if (d.length <= 12) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8)}`;
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`;
}

export const REGULAMENTO_PADRAO = `1. Serão vendidos números de 0001 em diante, ao valor unitário indicado.
2. A ação entre amigos ocorrerá na data, hora e meio informados.
3. Caso o número apurado não tenha sido vendido, apura-se outro no mesmo ato.
4. Cada prêmio tem o seu próprio número; um mesmo número não leva dois prêmios.
5. O prêmio será entregue em até 30 dias, mediante apresentação do comprovante.`;

export const MAX_PREMIOS = 20;

// Badge ordinal: 1º, 2º, 3º…
export function ordinal(n: number): string {
  return `${n}º`;
}

let contadorChave = 0;
export function novaChave(): string {
  contadorChave += 1;
  return `premio-${Date.now()}-${contadorChave}`;
}

export function novoPremio(): PremioDraft {
  return { chave: novaChave(), desc: '', doou: '', foto: null, fotoUrl: null };
}

// Monta a data/hora ISO do sorteio (usa o mesmo helper do assistente).
export function dataHoraSorteioISO(data: string, hora: string): string | null {
  if (!data) return null;
  const h = hora || '00:00';
  const d = new Date(`${data}T${h}:00`);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
}